import React, { createContext, useReducer } from 'react';
import { Header, Modal, Segment } from 'semantic-ui-react';
import FormModalTipoSimulacao from '../../containers/FormModalTipoSimulacao';
import styles from './styles.module.scss';

export const ModalTipoSimulacaoContext = createContext({
    maxHeight: false,
    visible: false,
    setMaxHeight() {},
    setVisible() {}
});
/**
 *
 * @param {*} state
 * @param {{type: 'ON_CHANGE', payload: any}} action
 */
function reducer(state = { maxHeight: false, visible: false }, action) {
    if (action.type === 'ON_CHANGE') {
        return {
            ...state,
            ...action.payload
        };
    }
    return state;
}
export function ModalTipoSimulacaoHandler(props) {
    const { children, checkedForBroto } = props;
    const [state, dispatch] = useReducer(reducer, { maxHeight: false, visible: false, checkedForBroto });

    function setVisible(visible) {
        dispatch({
            type: 'ON_CHANGE',
            payload: {
                visible
            }
        });
    }

    function setMaxHeight(maxHeight) {
        dispatch({
            type: 'ON_CHANGE',
            payload: {
                maxHeight
            }
        });
    }

    return (
        <ModalTipoSimulacaoContext.Provider value={{ ...state, checkedForBroto, setVisible, setMaxHeight }}>
            {children}
        </ModalTipoSimulacaoContext.Provider>
    );
}

export default function ModalTipoSimulacao({ context }) {
    const { maxHeight, visible, setVisible, setMaxHeight, checkedForBroto } = context;
    const estilo = {
        width: 494,
        transition: '2s',
        maxHeight: maxHeight ? 358 : null
    };

    return (
        <>
            {visible && (
                <Modal
                    open={visible}
                    centered
                    closeOnDimmerClick={false}
                    closeOnEscape
                    onClose={() => setVisible(false)}
                    style={estilo}
                    closeIcon
                >
                    <Modal.Content>
                        <Segment basic padded={false} textAlign='center'>
                            <Header className={styles.darkBlue}>Seja bem-vindo(a)!</Header>
                            <p>Informe os dados abaixo para iniciar a Simulação.</p>
                            <FormModalTipoSimulacao
                                handlerSetHeight={() => setMaxHeight(!maxHeight)}
                                checkedForBroto={checkedForBroto}
                            />
                        </Segment>
                    </Modal.Content>
                </Modal>
            )}
        </>
    );
}
